import { Injectable, OnDestroy, Output, EventEmitter } from '@angular/core'
//import { Http } from '@angular/http'
import { HttpClient, HttpResponse } from '@angular/common/http'
import { Observable } from 'rxjs/Observable'
import { AuthService } from './auth.service'
import { appStateProvider } from '../insa-providers/AppStateProvider'
import { appConfig } from '../../insaweb.config'
import { LocalizeService } from './localize.service';
import {SharedMethodsModule} from '../insa-custom-scripts/sharedMethods';
import {InsaChronosJobModel, ChronosActivitiesModel, ImportJobDetails, ProcessJobDetails, ChronosActivityResultActions, InterfaceJobDetails, ReportJobDetails, EmailJobDetails, SMSJobDetails, TaskActivityDetails, ObjectCreationNotifierDetails } from '../insa-models';
import { map, catchError, publishReplay, refCount } from 'rxjs/operators'
import { ObservedValueOf } from 'rxjs'


@Injectable()
export class InsaCronService implements OnDestroy{

    private language = 'en';
    private hostAddress = appConfig.insaServiceAddress;
    private servicesURL = "/InsaChronos";
    authServiceSubscription;
    chronosJob: InsaChronosJobModel[] = new Array<InsaChronosJobModel>();
    chronosActivities: ChronosActivitiesModel[] = new Array<ChronosActivitiesModel>();
    //stateSubscription;
    activityTypes: any;
    banks:any;
    imports: any;
    processes: any;
    priorities: any;
    postActivities: any;
    options: any;
    jobId: any;
    interfaceDetails: any;
    getData: any;

   @Output() JobActivitiesEvent: EventEmitter<ChronosActivitiesModel[]> = new EventEmitter<ChronosActivitiesModel[]>(true);
   @Output() JobEvent: EventEmitter<InsaChronosJobModel[]> = new EventEmitter<InsaChronosJobModel[]>(true);
   @Output() ActivityTypesEvent: EventEmitter<any[]> = new EventEmitter<any[]>(true);
   @Output() BanksEvent: EventEmitter<any[]> = new EventEmitter<any[]>(true);


    constructor(private _appStateProvider: appStateProvider, private http: HttpClient, private _authService: AuthService, private _localize: LocalizeService) {
        this.language = this._localize.getLocale().substring(0, 2);
        //this.stateSubscription = _appStateProvider.subscribe(eventdata => this.initDataFetching(eventdata));
        this.authServiceSubscription = this._authService.LoggedInStatusChangedEmitter.subscribe((loggedIn) => {
            if(loggedIn.value === false){
                this.language = this._localize.getLocale().substring(0, 2);
            }
          
        });
    }

    initDataFetching(e) {
        this.language = this._localize.getLocale().substring(0, 2);
        //this.getJob();
    }

    getJob(): Observable<InsaChronosJobModel[]>{
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        //let timeStamp = +new Date();
        this._appStateProvider.fetchingChronosJob = true;
        
        let req = this.http.get<InsaChronosJobModel[]>(
            this.hostAddress + this.servicesURL + "/Job",
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any job")));
            //.map((res) => {
                //this._appStateProvider.fetchingChronosJob = false;                
                //return res.json()
            //});
        return req; 
    }

    getPostActions(activityId: any): Observable<ChronosActivityResultActions[]>{
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        //let timeStamp = +new Date();

       return this.http.get<ChronosActivityResultActions[]>(
            this.hostAddress + this.servicesURL + "/PostActions?activityID=" + activityId,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any activity action")))
      }

      updatePostAction(postAction :any){
        let headers = this._authService.getAuthHeaders('application/json');
        let body = JSON.stringify(postAction);

        const url = this.hostAddress  + this.servicesURL + "/PostActions";
        return this.http.put(url, body, { headers }).pipe(
        catchError(err => 
           this.handleError(err, "couldn't update post action" + postAction.PostActivityID + " .Please, check sth")));
     }

     deletePostAction(postActivityID:number, activityID: number, priorityID: number){
        let headers = this._authService.getAuthHeaders('application/json');

        const url = this.hostAddress +  this.servicesURL + '/PostActions?postActivityID='+ postActivityID +'?activityID=' + activityID + '?priorityID=' + priorityID;
        return this.http.delete(url, {headers}).pipe(
        catchError(err => this.handleError(err, "Could not delete post actions " + postActivityID)));
     }

     addPostAction(postAction:any){
        let headers = this._authService.getAuthHeaders('application/json');
        let body = JSON.stringify(postAction);
        const url = this.hostAddress  + this.servicesURL + "/PostActions";

       return this.http.post(url ,body, {headers})
            .pipe(catchError(err => this.handleError(err, "Could not add post action, please check sth")))
     }

    getPriorities(){
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        //let timeStamp = +new Date();

      return this.http.get(
            this.hostAddress + this.servicesURL + "/Priorities",
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any priprity")))
     }

    getBanks(){
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        //let timeStamp = +new Date();
        let banks: any;

        //return this.http.get(
        let req = this.http.get(
            this.hostAddress + this.servicesURL + "/Banks",
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any bank")))
        return req;
        }

    getActivityType(){
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');

        let req = this.http.get(
            this.hostAddress + this.servicesURL + "/ActivityType",
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any type")))

        req.subscribe(data=>{
            this.activityTypes = data,
            this.ActivityTypesEvent.emit(this.activityTypes)
        })
        return req;
      }

    getOptions(){
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        //let timeStamp = +new Date();

       return this.http.get(
            this.hostAddress + this.servicesURL + "/Options?language=" + this.language,
            { headers }).pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any option")))
            //.map(res => res.json());
            
     }
     
    getReportFilters(optionId: number){
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        //let timeStamp = +new Date();

        return this.http.get(
            this.hostAddress + this.servicesURL + "/ReportFilters?optionId=" + optionId,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any report filters")))
            //.map(res => res.json());
        }

    getProcesses(){
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        //let timeStamp = +new Date();

       return this.http.get(
            this.hostAddress + this.servicesURL + "/Process?language=" + this.language,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any process")))
     }

    getProcessById(activityId: number): Observable<ProcessJobDetails[]> {
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        let processByID;
        //let timeStamp = +new Date();

        let req = this.http.get<ProcessJobDetails[]>(
            this.hostAddress + this.servicesURL + "/ProcessDetails?activityID=" + activityId,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any process")))
        return req;
    }

    // holi - we don't use it
    /*getJobById(JobId: number){

     this.language = this._localize.getLocale().substring(0, 2);
     let headers = this._authService.getAuthHeaders('application/json');
     const url = this.hostAddress  + this.servicesURL + '/Job?JobID='+ JobId;

     return this.http.get(url ,{ headers })
         .publishReplay().refCount()
         .catch(err => this.handleError(err, "Could not get any job"))
    };*/

    getActivityByJobId(JobId: number): Observable<ChronosActivitiesModel[]> {
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        const url = this.hostAddress + this.servicesURL + '/JobActivities?JobID=' + JobId;

        let req = this.http.get<ChronosActivitiesModel[]>(url, { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any activities")))
        /*req.subscribe(data => {
            this.JobActivitiesEvent.subscribe(data);
            this.chronosActivities = data;
        });*/
        return req;
    };

    getInterfaceDetails(activityId: number): Observable<InterfaceJobDetails[]> {
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        const url = this.hostAddress + this.servicesURL + '/InterfaceDetails?activityID=' + activityId;
        let req = this.http.get<InterfaceJobDetails[]>(url, { headers })
        .pipe(
            publishReplay(),
            refCount(),
            catchError(err => this.handleError(err, "Could not get any job")))
        /*.map((res)=> {
                return res.json();
                });*/
        return req;
    };

    // getReportDetailsID(activityID: number){
    //   this.language = this._localize.getLocale().substring(0,2);
    //   let headers = this._authService.getAuthHeaders('application/json');
    //   const url = this.hostAddress + this.servicesURL + '/ReportDetails?acitivityID='+ activityID;
    //   let req = this.http.get(url, {headers, body: ''})
    //     .publishReplay().refCount()
    //     .catch(err => this.handleError(err, "Could not get any report details"))
    //     .map(res => res.json());
    //   req.subscribe(data => {
    //       console.log(data);
    //   });
    //   return req;
    // }

    getImportDetails(): Observable<ImportJobDetails[]> {
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        return this.http.get<ImportJobDetails[]>(
            this.hostAddress + this.servicesURL + "/ImportTypes?language=" + this.language,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any import details")))
    }

    getImportDetailsById(activityId: number):Observable<ImportJobDetails[]>{
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        //let timeStamp = +new Date();
       return this.http.get<ImportJobDetails[]>(
            this.hostAddress + this.servicesURL + "/ImportDetails?activityID=" + activityId,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any process")))
       }

    getReportDetailsbyID(activityId: number): Observable<ReportJobDetails[]>{
        this.language = this._localize.getLocale().substring(0,2);
        let headers = this._authService.getAuthHeaders('application/json');
        return this.http.get<ReportJobDetails[]>(
            this.hostAddress + this.servicesURL + "/ReportDetails?activityID=" + activityId,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err=> this.handleError(err, "Could not get any report details")))
    }


    getEmailDetailsById(activityId: number): Observable<EmailJobDetails[]> {
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        //let timeStamp = +new Date();
        return this.http.get<EmailJobDetails[]>(
            this.hostAddress + this.servicesURL + "/EmailDetails?activityID=" + activityId,
            { headers })
            .pipe(publishReplay(),
            refCount(),
            catchError(err => this.handleError(err, "Could not get any process")))
            //.map(res => res.json());
    }

    getSMSDetailsById(activityId: number): Observable<SMSJobDetails[]> {
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        //let timeStamp = +new Date();
        return this.http.get<SMSJobDetails[]>(
            this.hostAddress + this.servicesURL + "/SMSDetails?activityID=" + activityId,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any process")))
            //.map(res => res.json());
    }

    getTaskActivityByID(activityId: number): Observable<TaskActivityDetails>{
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        return this.http.get<TaskActivityDetails>(
            this.hostAddress + this.servicesURL + "/TaskDetails?activityID=" + activityId,
            { headers })
            .pipe(publishReplay(),
            refCount(),
            catchError(err => this.handleError(err, "Could not get any task activity")))
            //.map(res => res.json());
    }

    getUserAcc() {
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        //let timeStamp = +new Date();

        return this.http.get(
            this.hostAddress + this.servicesURL + "/UserAccData",
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any report filters")))
            //.map(res => res.json());

    }

    getObjectNotifierTypes() {
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        return this.http.get(
            this.hostAddress + this.servicesURL + "/ObjectNotifierTypes",
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any objectNotifier details")))
            //.map(res => res.json());
    }

    getObjectNotifierDetailsById(activityId: number): Observable<ObjectCreationNotifierDetails[]>{
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        //let timeStamp = +new Date();
       return this.http.get<ObjectCreationNotifierDetails[]>(
            this.hostAddress + this.servicesURL + "/ObjectNotifierDetails?activityID=" + activityId,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any objectNotifier")))
            //.map(res => res.json());
       }


     addJob(job:any){
        let headers = this._authService.getAuthHeaders('application/json');
        let body = JSON.stringify(job);
        const url = this.hostAddress  + this.servicesURL + '/Job';

       return this.http.post(url ,body, {headers})
            .pipe(
            catchError(err => this.handleError(err, "Could not add job, please check sth")))
        }
     
     updateJob(job:any){
        let headers = this._authService.getAuthHeaders('application/json');
        let body = JSON.stringify(job);
        const url = this.hostAddress  + this.servicesURL + '/Job';

        return this.http.put(url, body, { headers })
        .pipe(
        catchError(err => this.handleError(err, "Could not update job" + job.name + " .Please, check sth")));
     }

     addJobActivity(activity:any){
        let headers = this._authService.getAuthHeaders('application/json');
        let body = JSON.stringify(activity);
        const url = this.hostAddress  + this.servicesURL + "/JobActivities";

       return this.http.post(url, body, {headers})
            .pipe(
                catchError(err => this.handleError(err, "Could not add job, please check sth")))
     }

     updateJobActivity(jobActivity :any){
        let headers = this._authService.getAuthHeaders('application/json');
        let body = JSON.stringify(jobActivity);

        const url = this.hostAddress  + this.servicesURL + "/JobActivities";
        return this.http.put(url, body, { headers })
        .pipe(
            catchError(err => 
           this.handleError(err, "couldn't update job" + jobActivity.Description + " .Please, check sth")));
     }

     deleteJobActivity(activityID:any): Observable<HttpResponse<any>>{
        let headers = this._authService.getAuthHeaders('application/json');

        const url = this.hostAddress +  this.servicesURL + '/JobActivities?activityID='+ activityID;
        return this.http.delete(url, {headers, observe: 'response' })
        .pipe(
            catchError(err => this.handleError(err, "Could not delete activity " + activityID)));
     }

      deleteJob(jobId: number){

        let headers = this._authService.getAuthHeaders('application/json');
        const url = this.hostAddress +  this.servicesURL + '/Job?jobID=' + jobId;

        return this.http.delete(url,  {
            headers: headers})
            .pipe(
                catchError(err => this.handleError(err, "Could not delete job " + jobId)));
      }

    private handleError(error: any, message: string) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
            SharedMethodsModule.addNotification("#notification", message, false);    
        return Observable.throw(errMsg);
    }

    getAllPostaActions(jobId: any): Observable<ChronosActivityResultActions[]>{

        let headers = this._authService.getAuthHeaders('application/json');

        return this.http.get<ChronosActivityResultActions[]>(
            this.hostAddress + this.servicesURL + "/AllPostActions?jobID=" + jobId,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any activity action")) )
            //.map(res => res.json());
     }

     /*getReport(): Observable<any[]>{
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        //let timeStamp = +new Date();

       return this.http.get<any[]>(
            this.hostAddress + this.servicesURL + "/Report",
            { headers }).pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any option")))
            //.map(res => res.json());
            
     }*/

    getReportByCollId(filterID: number, isCollID: boolean, initCollectionID: number, initReportID: number, activityID: number): Observable<any[]> {
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        //let timeStamp = +new Date();

        return this.http.get<any[]>(
            this.hostAddress + this.servicesURL + '/ReportByCollId?filterID=' + filterID 
			+ '&isCollectionID=' + isCollID 
            + '&collID=' + initCollectionID 
            + '&repID=' + initReportID 
            + '&activityID=' + activityID
            + '&language=' + this.language,
            { headers }).pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any option")))
        //.map(res => res.json());

    }

    /*getSubReport(): Observable<any[]> {
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        //let timeStamp = +new Date();

        return this.http.get<any[]>(
            this.hostAddress + this.servicesURL + "/SubReport",
            { headers }).pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any option")))
        //.map(res => res.json());

    }*/

    getSubReportbyId(filterID: number, isCollID: boolean, initCollectionID: number, initReportID: number, activityID: number): Observable<any[]> {
        this.language = this._localize.getLocale().substring(0, 2);
        let headers = this._authService.getAuthHeaders('application/json');
        //let timeStamp = +new Date();

        return this.http.get<any[]>(
            this.hostAddress + this.servicesURL + '/SubReportById?filterID=' + filterID + '&isCollectionID=' + isCollID 
            + '&collID=' + initCollectionID 
            + '&repID=' + initReportID 
            + '&activityID=' + activityID
            + '&language=' + this.language,
            { headers }).pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Could not get any option")))
        //.map(res => res.json());

    }


    getReportDetailsListbyID(activityID: number): Observable<any>{
        this.language = this._localize.getLocale().substring(0,2);
        let headers = this._authService.getAuthHeaders('application/json');

        return this.http.get<any>(
            this.hostAddress + this.servicesURL + "/ReportDetailsListByID?ActivityID=" + activityID, 
            { headers }
        ).pipe(
            publishReplay(),
            refCount(),
            catchError(err => this.handleError(err, "Could not get subreport list"))
        )
    }

    copyJob(jobName: string, jobID: number){
        let headers = this._authService.getAuthHeaders('application/json');
        const url = this.hostAddress  + this.servicesURL + '/JobCopy?jobID=' + jobID + '&jobName=' + jobName;


       return this.http.post(url, "", {headers})
            .pipe(
            catchError(err => this.handleError(err, "Could not copy job, please check sth")))
        }


    ngOnDestroy() {
        //this.stateSubscription.unsubscribe();
        this.authServiceSubscription.unsubscribe();
    }

}


// WEBPACK FOOTER //
// ./app/insa-services/insa-cron.service.ts